// Ponte entre o evento de troca de variante dos scripts conso e o do Horizon 4.
//
// PROBLEMA
// Na 3.x o tema anunciava a troca de variante com eventos próprios, declarados
// no `events.js`:
//
//     document.dispatchEvent(new CustomEvent('variant:update', {
//       detail: { resource: <objeto da variante> }
//     }))
//
// Vários snippets conso penduram a re-aplicação deles nisso — a galeria por cor
// do costume, o swatch de cor, o aviso de indisponibilidade, o prazo de entrega
// e a galeria por cor padrão.
//
// A 4.x migrou para os Shopify Standard Events. `variant:update` e
// `variant:selected` sumiram do `events.js` e ninguém mais os dispara. No lugar
// entrou `shopify:product:select`, emitido pelo <variant-picker> ANTES do fetch,
// com uma promise anexada que resolve DEPOIS do morph, com
// `{ variant, detail: { html, resource, ... } }`.
//
// Resultado: os snippets conso decoram o DOM no load e nunca mais. Na troca de
// cor o morph do variant-picker apaga a decoração (o swatch de cor volta a ser
// botão com o nome escrito) e o filtro da galeria reaplica com a cor ANTIGA,
// porque nada atualizou qual variante está selecionada. Um F5 conserta — é o
// load acontecendo de novo.
//
// SOLUÇÃO
// Escutar o evento da 4.x e re-emitir `variant:update` no formato da 3.x. O
// `detail.resource` da 4.x já é o objeto da variante (com `.id`), o mesmo que a
// 3.x entregava: a ponte é fiel, não uma tradução. Fica num arquivo só e cobre
// qualquer snippet conso que use o padrão antigo.
//
// TEMPO
// O listener fica no `document`, na fase de bubbling. Os componentes do tema
// escutam em elementos abaixo (a <media-gallery> escuta na `.shopify-section`
// mais próxima), então os `.then` deles são registrados antes do nosso e rodam
// primeiro. Quando a ponte dispara, o morph do picker e o replaceWith da galeria
// já aconteceram — que é exatamente quando os snippets conso precisam reaplicar.

(function () {
  var EVENTO_V4 = 'shopify:product:select';
  var EVENTO_LEGADO = 'variant:update';

  function emitir(resource, sourceId) {
    document.dispatchEvent(
      new CustomEvent(EVENTO_LEGADO, {
        bubbles: true,
        detail: { resource: resource || null, sourceId: sourceId || null },
      })
    );
  }

  // Quando a promise não traz a variante (combinação indisponível, por exemplo),
  // o id síncrono do evento ainda diz qual variante o cliente escolheu.
  function variantePeloDetail(ev) {
    var id = ev && ev.detail && ev.detail.variantId;
    return id ? { id: id } : null;
  }

  document.addEventListener(EVENTO_V4, function (ev) {
    var sourceId = ev && ev.detail ? ev.detail.optionValueId : null;
    var promise = ev && ev.promise;

    if (!promise || typeof promise.then !== 'function') {
      // Sem promise não há morph para esperar: só o próximo frame.
      requestAnimationFrame(function () {
        emitir(variantePeloDetail(ev), sourceId);
      });
      return;
    }

    promise
      .then(function (resultado) {
        var detail = resultado && resultado.detail;
        emitir(
          (detail && detail.resource) || (resultado && resultado.variant) || variantePeloDetail(ev),
          sourceId
        );
      })
      .catch(function () {
        // Fetch abortado (o cliente trocou de opção de novo) — o evento da nova
        // escolha vem logo atrás. Emitir aqui só faria os snippets reaplicarem
        // com a variante errada.
      });
  });
})();
